import React, { useContext } from 'react';
import {
  Route, Redirect, RouteProps,
} from 'react-router-dom';
import { AuthenticationContext } from '../contexts/Authentication';


export default function PrivateRoute({
  location,
  component,
  render,
  children,
  path,
  exact,
  sensitive,
  strict,
}: RouteProps) {
  const authContext = useContext(AuthenticationContext);
  if (authContext.state?.authenticated) {
    return (
      <Route
        location={location}
        component={component}
        render={render}
        path={path}
        exact={exact}
        sensitive={sensitive}
        strict={strict}
      >
        {children}
      </Route>
    );
  }
  return <Redirect to="/login" />;
}
